var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Play/Icon",
    d: "M16.4844 0.289062C7.65238 0.289062 0.484375 7.45706 0.484375 16.2891C0.484375 25.1211 7.65238 32.2891 16.4844 32.2891C25.3164 32.2891 32.4844 25.1211 32.4844 16.2891C32.4844 7.45706 25.3164 0.289062 16.4844 0.289062ZM20.7404 19.0571L18.6924 20.2411L16.6444 21.4251C14.0044 22.9451 11.8444 21.6971 11.8444 18.6571V16.2891V13.9211C11.8444 10.8651 14.0044 9.63306 16.6444 11.1531L18.6924 12.3371L20.7404 13.5211C23.3804 15.0411 23.3804 17.5371 20.7404 19.0571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.58f533daf6f530e9f37a9ec56692d5f6.svg";
export { ForwardRef as ReactComponent };